import React, {memo} from 'react';
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';
import {isMobile} from 'react-device-detect';
import {useTheme} from '@redlink/assets/styles';
import {useLocale} from "@redlink/assets/locale";

export const DragableFlatList = memo(
    ({data = [], renderItem, ItemSeparatorComponent, onDragEnd}) => {
        const {size} = useTheme();
        const {isRtl} = useLocale();
        return (
            <DragDropContext {...{onDragEnd}}>
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                            {data.map((item, index) => (
                                <Draggable key={item.id} draggableId={item.id} index={index}>
                                    {(provided, snapshot) => {
                                        if (snapshot.isDragging) {
                                            if (!isRtl && !isMobile) provided.draggableProps.style.left -= size.drawerWidth;
                                            provided.draggableProps.style.top -= isMobile
                                                ? size.mobileHeaderHeight // header height
                                                : size.headerHeight + size.adsBoxHeight; // header + ads height;
                                        }
                                        return (
                                            <div ref={provided.innerRef} {...provided.draggableProps}>
                                                {ItemSeparatorComponent && ItemSeparatorComponent()}
                                                {renderItem({
                                                    item,
                                                    index,
                                                    dragHandle: provided.dragHandleProps,
                                                })}
                                            </div>
                                        );
                                    }}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        );
    }
);
